import { useCallback, useEffect } from 'react'

import { useGetContractTemplateQuery } from '../../../../api/plamo-api'
import PlamoApiWithSaveNotifications from '../../util/with-save-notification'
import { Breadcrumb, Button, Col, Form, Row, Space, Tabs, theme } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'

import { HomeOutlined } from '@ant-design/icons';
import FormItem from '../../form/form-item';
import { IconFileSignatureSolid } from '../../../../icon';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import Editor from '../../util/editor'

const { useCreateContractTemplateWithSaveNotificationMutation, useUpdateContractTemplateWithSaveNotificationMutation } = PlamoApiWithSaveNotifications;

function ContractTemplateDetailsPage() {
  const [createContractTemplate, { isLoading: isCreatingContractTemplate }] = useCreateContractTemplateWithSaveNotificationMutation();
  const [updateContractTemplate, { isLoading: isUpdatingContractTemplate }] = useUpdateContractTemplateWithSaveNotificationMutation();
  const { id } = useParams();
  const { data: contractTemplate } = useGetContractTemplateQuery({ id }, { skip: id === 'new' }) as { data: any }
  const [form] = Form.useForm();
  const navigate = useNavigate();
 
  const isLoading = isCreatingContractTemplate || isUpdatingContractTemplate;

  const { token } = theme.useToken();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  useEffect(() => {
    console.log("Set contract template", contractTemplate)
    form.setFieldsValue(contractTemplate)
  }, [form, contractTemplate])
  
  const onFinish = useCallback(async (values: any) => {
    values = {
      ...values, 
      text: values.text?.replace(/<p class="ql-align-((justify)|(center))"><br\/?><\/p>/g, '').replace(/<p class="ql-indent-1"><br\/?><\/p>/g, '').replace(/<p><br\/?><\/p>/g, '') || contractTemplate?.text,
      letterText: values.letterText?.replace(/<p class="ql-align-((justify)|(center))"><br\/?><\/p>/g, '').replace(/<p class="ql-indent-1"><br\/?><\/p>/g, '').replace(/<p><br\/?><\/p>/g, '') || contractTemplate?.letterText, 
    }
    console.log("Values on submit", values)
    if(id === 'new') {
      const { data: newContractTemplate }:any = await createContractTemplate(values);
      console.log("Created new assignment", newContractTemplate);
      navigate(`./../${newContractTemplate.id}`, { replace: true })
    } else {
      const newContractTemplate = {...contractTemplate, ...values}
      await updateContractTemplate(newContractTemplate);
    }
  }, [id, createContractTemplate, updateContractTemplate, navigate, contractTemplate]);

  return (
    <div style={{ height: "100%", overflow: "scroll" }}>
       <Breadcrumb
          style={{ marginBottom: "24px" }}
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined />,
            },
            {
              onClick: () => navigate('/assignment'),
              title: (
                <>
                  <IconFileSignatureSolid />
                  <span>Vertragsvorlagen</span>
                </>
              ),
            },  
            {
              title: `${contractTemplate?.title ?? 'unbekannt'}`
            },            
          ]}
        />
      <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
        <Row><h3>Vertragsvorlage</h3></Row>
        <Row gutter={24}>
          <FormItem fieldName="contractType" label="Vertragsart" type="enum" typeData={{ options: [{ value: "customer", label: "Kundenvertrag" }, { value: "employee", label: "Mitarbeitervertrag" }] }}/>
          <FormItem fieldName="title" label="Titel" />
        </Row>
        <Row>
          <Col span={24}>
            <Tabs defaultActiveKey='text' items={[
              {
                key: 'letterText',
                label: 'Anschreiben',
                children: (
                  <Form.Item
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    name={"letterText"}
                  >
                    <Editor />
                  </Form.Item>
                )
              },
              {
                key: 'text',
                label: 'Vertragstext',
                children: (
                  <Form.Item
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    name={"text"}
                  >
                    <Editor />
                  </Form.Item>
                )
              }
            ]} />
          </Col>
        </Row>
        <div style={{ textAlign: 'right' }}>
          <Space size="small">
            <Button loading={isLoading} type="primary" htmlType="submit">
              Speichern
            </Button>
          </Space>
        </div>
      </Form>

    </div>
  )
}

export default ContractTemplateDetailsPage